import { IWithdrawDetails } from '@/modules/transaction/services/withdraw-by-portfolio';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';

const isOnGoingRedemptionEnabled = FeatureFlagsModule.isEnabled(
  FeatureFlags.ENABLE_ON_GOING_REDEMPTIONS
);

export const getStatus = (amount: number, details: IWithdrawDetails) => {
  if (amount > 0 && amount < details.minimumRedemption.value) {
    return 'error';
  }

  if (amount > details.availableToRedemption.value) {
    return 'error';
  }
  return '';
};

export const getHelperText = (amount: number, details: IWithdrawDetails) => {
  if (amount > 0 && amount < details.minimumRedemption.value) {
    return `O valor mínimo de resgate é de ${details.minimumRedemption.formatted}. Escolha um valor maior ou igual para resgatar.`;
  }

  if (amount > details.availableToRedemption.value) {
    const availableToRedemption = details.availableToRedemption.formatted;

    if (isOnGoingRedemptionEnabled) {
      const isInRedemption = details.inRedemption.value < 0;
      const isInRebalance = details.inRebalance.value < 0;

      if (isInRedemption && isInRebalance) {
        return `Você só pode resgatar até ${availableToRedemption} porque parte do valor está em resgate e em rebalanceamento.`;
      }

      if (isInRedemption) {
        return `Você só pode resgatar até ${availableToRedemption} porque parte do valor está em resgate.`;
      }

      if (isInRebalance) {
        return `Você só pode resgatar até ${availableToRedemption} porque parte do valor está em rebalanceamento.`;
      }
    }

    return `O valor disponível para resgate desta carteira é de ${availableToRedemption}. Escolha um valor menor ou igual para resgatar.`;
  }

  return '';
};

export const getDetails = (
  details: IWithdrawDetails,
  netValue: string,
  fetchingNetValue: boolean
) => {
  return [
    { title: 'Líquido estimado', value: netValue, loading: fetchingNetValue },
    {
      title: 'Mínimo para resgate',
      value: details.minimumRedemption.formatted,
      loading: false
    },
    {
      title: 'Prazo total de resgate',
      value: details.totalRedemptionPeriod,
      loading: false
    }
  ];
};
